import { Row, Col, Form, Button } from "react-bootstrap";
import { RiSearchLine, RiFilterLine } from "react-icons/ri";

export default function BookingFilters() {
  return (
    <div className="bh-filters">

      <Row className="align-items-end g-3">

        {/* SEARCH */}
        <Col xl={3} lg={5} md={12}>
          <div className="bh-field">
            <label>Search</label>
            <div className="bh-search">
              <RiSearchLine />
              <input placeholder="Search by reservation, driver, truck, plate..." />
            </div>
          </div>
        </Col>

        {/* STATUS */}
        <Col xl={2} lg={3} md={4}>
          <div className="bh-field">
            <label>Status</label>
            <Form.Select>
              <option>All Status</option>
            </Form.Select>
          </div>
        </Col>

        {/* YARD */}
        <Col xl={2} lg={3} md={4}>
          <div className="bh-field">
            <label>Yards</label>
            <Form.Select>
              <option>All Yards</option>
            </Form.Select>
          </div>
        </Col>

        {/* DRIVER */}
        <Col xl={2} lg={3} md={4}>
          <div className="bh-field">
            <label>Drivers</label>
            <Form.Select>
              <option>All Drivers</option>
            </Form.Select>
          </div>
        </Col>

        {/* DATE */}
        <Col xl={2} lg={3} md={6}>
          <div className="bh-field">
            <label>Date Range</label>
            <Form.Control type="text" placeholder="Date Range" />
          </div>
        </Col>

        {/* FILTER BUTTON */}
        <Col xl={1} lg={2} md={6}>
          <Button className="bh-filter-btn w-100"> Reset
          </Button>
        </Col>

      </Row>

    </div>
  );
}